(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-verification"] && !Shopify.designMode) return;
  try {
    const ageVerification = document.querySelector('[data-age-verification]');

  if (ageVerification) {
    const storageKey = ageVerification.dataset.storageKey;
    const thirtyDays = 30 * 24 * 60 * 60 * 1000;
    let verifiedUntil = 0;

    try {
      verifiedUntil = Number(window.localStorage.getItem(storageKey)) || 0;
    } catch (error) {
      verifiedUntil = 0;
    }

    if (verifiedUntil <= Date.now()) {
      ageVerification.showModal();
      document.documentElement.classList.add('age-verification-open');
    }

    ageVerification.addEventListener('cancel', (event) => {
      event.preventDefault();
    });

    ageVerification.querySelector('[data-age-confirm]').addEventListener('click', () => {
      try {
        window.localStorage.setItem(storageKey, String(Date.now() + thirtyDays));
      } catch (error) {
        verifiedUntil = 0;
      }

      ageVerification.close();
      document.documentElement.classList.remove('age-verification-open');
    });
  }
  } catch(e) { console.error(e); }
})();

})();
